import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidenav-item',
  templateUrl: './sidenav-item.component.html',
  styleUrls: ['./sidenav-item.component.css']
})
export class SidenavItemComponent implements OnInit {

  @Input() public itemIcon: string = '';
  @Input() public itemTitle: string = '';
  @Input() public itemRouterLink: string = '';
  @Input() public itemTitleColorHover: string = '';
  @Input() public itembackgroundColorHover: string = '';
  @Input() public itemTitleColor: string = '';
  @Input() public itemClick:string = '';
  @Input() public subMenu:boolean = false;

  public itemStyle: string = '';

  constructor() { }

  ngOnInit(): void {
    this.mouseLeave();
  }

  mouseEnter()
  {
    this.itemStyle = "color: " + this.itemTitleColorHover + "; fill: " + this.itemTitleColorHover
    + "; backgroundColor: " + this.itembackgroundColorHover + ";";
  }

  mouseLeave()
  {
    this.itemStyle = "color: " + this.itemTitleColor + "; fill: " + this.itemTitleColor + ";";
  }

}


